module.exports = __webpack_public_path__ + "static/BannerBlog-9a71af14035daeb3459ae45f36e788e3.png";